import React from "react";
import "./style.css";
import { Link } from "react-router-dom";
import Button from "../CtaButton";

const DevelopmentPerformance = ({
  heading,
  subHeading,
  solutions,
  greenHeading,
  BorderClass,
  buttonText,
}) => {
  return (
    <>
      <div className="future-solutions-box">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h4 className="engagment-model-text">
                {heading} <span>{greenHeading}</span>
              </h4>
              <h3 className="sub-heading">{subHeading}</h3>
            </div>
          </div>

          <div className={`row border-box-industry ${BorderClass}`}>
            {solutions.map((solution, index) => (
              <div
                className={`col-md-6 ${solution.noBorder ? "none-border" : ""}`}
                key={index}
              >
                {solution?.icon && (
                  <div className="icon-image-here">
                    <img src={solution?.icon} alt={`${solution?.icon}`} />
                  </div>
                )}

                <div className="development-services-text-box">
                  <h4>{solution.title}</h4>
                  <p className="common-text">{solution.description}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="w-100 d-flex justify-content-center mt-5">
            <Button
              text={buttonText || "Hire a developer today"}
              link="/contact-us"
              hideIcon
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default DevelopmentPerformance;
